"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaOptionsResponseToJSON = exports.CtaOptionsResponseFromJSONTyped = exports.CtaOptionsResponseFromJSON = exports.instanceOfCtaOptionsResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CtaOptionsResponse interface.
 */
function instanceOfCtaOptionsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCtaOptionsResponse = instanceOfCtaOptionsResponse;
function CtaOptionsResponseFromJSON(json) {
    return CtaOptionsResponseFromJSONTyped(json, false);
}
exports.CtaOptionsResponseFromJSON = CtaOptionsResponseFromJSON;
function CtaOptionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ctaOptions': !(0, runtime_1.exists)(json, 'cta_options') ? undefined : json['cta_options'],
    };
}
exports.CtaOptionsResponseFromJSONTyped = CtaOptionsResponseFromJSONTyped;
function CtaOptionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cta_options': value.ctaOptions,
    };
}
exports.CtaOptionsResponseToJSON = CtaOptionsResponseToJSON;
